<template>
  <div class="flow-wrapper">
    <img
      v-for="index in 10"
      :key="index"
      src="@/assets/sds.png"
      class="image fall-animation"
      :style="getRandomStyles(index)"
    />
  </div>
</template>

<script setup lang="ts">
const getRandomStyles = (index: number) => {
  const randomLeft = Math.random() * 100;
  const randomDuration = Math.random() * 10 + 5;
  const randomDelay = Math.random() * 2;

  return {
    left: `${randomLeft}%`,
    animationDuration: `${randomDuration}s`,
    animationDelay: `${randomDelay}s`,
  };
};
</script>

<style scoped>
.flow-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; /* 改用 100% 而不是 100vh */
  pointer-events: none;
  z-index: 999;
  overflow: hidden; /* 添加 overflow: hidden */
}

.image {
  width: 2.5rem;
  position: absolute; /* 改用 absolute 而不是 fixed */
  pointer-events: none;
}

.fall-animation {
  position: absolute; /* 改用 absolute */
  top: -100px;
  animation: fall 3s linear infinite;
}

@keyframes fall {
  0% {
    transform: translateY(-100px); /* 使用 transform 代替 top */
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateY(100vh); /* 使用 transform 代替 top */
    opacity: 0;
  }
}
@media (max-width: 750px) {
  .image {
    width: 25px;
    position: absolute; /* 改用 absolute 而不是 fixed */
    pointer-events: none;
  }
}
</style>
